import { CloseOutlined } from '@ant-design/icons'
import { Button, Flex, Form, Input, Radio } from 'antd'
import PhoneInput from 'antd-phone-input'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = StepProps

export const StepCallTransfer: React.FC<Props> = props => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4} style={{ marginBottom: '32px' }}>
          Should I transfer the call, if needed?
        </TitlePrimary>

        <Flex vertical gap={8} className="w-full">
          <CommonClient.Form.InputWrapper
            label="Call Transfer"
            description="How should I transfer the call?"
            children={null}
          />

          <Form.Item shouldUpdate={true}>
            {options => {
              const isActive = options.getFieldValue([
                'callTransfer',
                'activated',
              ])

              if (!isActive) {
                return <></>
              }

              const mode = options.getFieldValue(['callTransfer', 'mode'])

              return (
                <>
                  <Form.Item name={['callTransfer', 'mode']}>
                    <Radio.Group
                      block={true}
                      optionType="button"
                      buttonStyle="solid"
                      options={[
                        {
                          label: 'Single',
                          value: 'single',
                        },
                        {
                          label: 'Multiple',
                          value: 'multiple',
                        },
                      ]}
                    />
                  </Form.Item>

                  {mode === 'single' && (
                    <>
                      <CommonClient.Form.InputWrapper children={null} />
                      <Form.Item
                        name={['callTransfer', 'phoneNumber']}
                        getValueFromEvent={value => {
                          if (
                            value.countryCode &&
                            value.areaCode &&
                            value.phoneNumber
                          ) {
                            return `+${value.countryCode}${value.areaCode}${value.phoneNumber}`
                          }

                          return null
                        }}
                        rules={[
                          {
                            required: true,
                          },
                          {
                            pattern: new RegExp('^\\+[1-9]\\d{1,14}$'),
                            message: `Invalid format.`,
                          },
                        ]}
                      >
                        <PhoneInput
                          enableSearch
                          disableParentheses
                          enableArrow
                          distinct
                          onlyCountries={['us']}
                        />
                      </Form.Item>
                    </>
                  )}

                  {mode === 'multiple' && (
                    <Form.List name={['callTransfer', 'options']}>
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map((field, index) => (
                            <Flex
                              key={field.key}
                              gap={1}
                              style={{ width: '100%' }}
                            >
                              <Form.Item
                                {...field}
                                style={{ flex: 1 }}
                                name={[field.name, 'phoneNumber']}
                                fieldKey={[field.fieldKey, 'phoneNumber']}
                                getValueFromEvent={value => {
                                  if (
                                    value.countryCode &&
                                    value.areaCode &&
                                    value.phoneNumber
                                  ) {
                                    return `+${value.countryCode}${value.areaCode}${value.phoneNumber}`
                                  }
                                  return null
                                }}
                                rules={[
                                  { required: true },
                                  {
                                    pattern: new RegExp('^\\+[1-9]\\d{1,14}$'),
                                    message: 'Invalid format.',
                                  },
                                ]}
                              >
                                <PhoneInput
                                  enableSearch
                                  disableParentheses
                                  enableArrow
                                  distinct
                                  onlyCountries={['us']}
                                />
                              </Form.Item>

                              <Form.Item
                                {...field}
                                style={{ flex: 1 }}
                                name={[field.name, 'condition']}
                                fieldKey={[field.fieldKey, 'condition']}
                                rules={[{ required: true }]}
                              >
                                <Input placeholder="Enter condition" />
                              </Form.Item>

                              {fields.length > 1 && (
                                <Button
                                  type="text"
                                  icon={<CloseOutlined />}
                                  onClick={() => remove(field.name)}
                                />
                              )}
                            </Flex>
                          ))}

                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => add()}
                              block
                              disabled={fields.length >= 5}
                            >
                              Add Phone Number
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  )}
                </>
              )
            }}
          </Form.Item>
        </Flex>
      </CommonClient.Onboarding.Step>
    </>
  )
}
